import MojitoCore from 'mojito/core';
import AbstractTask from 'services/common/task-runner/abstract-task.js';
import { actions as settledBetsActions } from 'services/bets/settled-bets/settled-bets-slice.js';
import { selectOddsFormat } from 'services/user-settings/selectors.js';
import { noop, isEmpty } from 'mojito/utils';

const { dispatch } = MojitoCore.Services.redux.store;

/**
 * Refresh settled bets task.
 *
 * Retrieves settled bets and handles result with proper action call.
 *
 * @class RefreshSettledBetsTask
 * @memberof Mojito.Services.Bets.Task
 */
export default class RefreshSettledBetsTask extends AbstractTask {
    constructor(service, maxBetAge, betsAmount) {
        super();
        this.betsService = service;
        this.maxBetAge = maxBetAge;
        this.betsAmount = betsAmount;
        this.dataHashRetriever = noop;
    }

    getFilterCriteria() {
        const dateSince = new Date();
        dateSince.setHours(dateSince.getHours() - this.maxBetAge);
        return {
            from: dateSince.toISOString(),
        };
    }

    setDataHashRetriever(hashRetriever = noop) {
        this.dataHashRetriever = hashRetriever;
    }

    execute(callback = noop) {
        const filterCriteria = this.getFilterCriteria();
        const oddsFormat = selectOddsFormat();
        const dataHash = this.dataHashRetriever();
        const hashPart = isEmpty(dataHash) ? {} : { dataHash };
        const recentAmount = this.betsAmount;
        this.betsService
            .refreshBets({ settled: true, recentAmount, filterCriteria, oddsFormat, ...hashPart })
            .then(data => dispatch(settledBetsActions.fetchSettledBetsSuccess(data)))
            .catch(() => dispatch(settledBetsActions.fetchSettledBetsFailed()));

        callback();
    }
}
